import { LandingPagesOccupations, SEO_URL_LANDING_PAGE_PREFIX } from "@authory-packages/seo-static-data";
import { ExamplesPageLayout } from "../../pagelayouts/examples";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";

const ExampleJobPage = () => (
    <ExamplesPageLayout
        title={<>Find the best portfolio solution for your profession</>}
        description={
            <>
                Explore how Authory works for writers, journalists, academics, marketers, and more. See how Authory supports the specific needs of
                your profession.
            </>
        }
        panelLinks={LandingPagesOccupations.map((occ) => ({
            url: `${APPLICATION_ROUTES.USE_CASES}/${SEO_URL_LANDING_PAGE_PREFIX}${occ.key}`,
            label: occ.occupation
        }))}
        categoriesLinks={[]}
        masonryItems={{ users: [] }}
        ogTitle={"Portfolio Use Cases by Profession | Authory"}
        ogDescription={"Explore Authory’s use cases by profession. Find the perfect fit for your role and showcase your best work effortlessly."}
        embedConf={[]}
        faq={[]}
    />
);

export default ExampleJobPage;
